import React, { FC } from 'react';
import { Box, LottiePlayerECOMMBX, Skeleton } from '@dxb-web-ui-framework/design-system';
import { ContentProps } from './types';
import { SuccessInfo, Actions } from './';

const DesktopContent: FC<ContentProps> = ({
  amount,
  currency,
  numberFormat,
  navigateToDashboard,
  onToggleDetails,
  onToggleTemplate,
  t,
  isLoading,
  isTransactionSettled,
  showTemplateSaveBtn,
  transactionId,
}) => (
  <>
    <Box>
      <SuccessInfo
        isLoading={isLoading}
        amount={amount}
        currency={currency}
        numberFormat={numberFormat}
        t={t}
        isTransactionSettled={isTransactionSettled}
        transactionId={transactionId}
      />
      <Actions
        navigateToDashboard={navigateToDashboard}
        onToggleDetails={onToggleDetails}
        onToggleTemplate={onToggleTemplate}
        t={t}
        isLoading={isLoading}
        showTemplateSaveBtn={showTemplateSaveBtn}
      />
    </Box>
    <Box maxHeight='520px' width='100%' height='100%' mt={isLoading ? 2 : 0} flex={1}>
      {isLoading ? (
        <Skeleton width='100%' height='100%'>
          <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
        </Skeleton>
      ) : (
        <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
      )}
    </Box>
  </>
);

export { DesktopContent };
